<template>
  <div>
    <TsNuxtCard append-class="rounded-none lg:rounded-xl shadow-none border-none">
      <TsTypography variant="h2" appendClass="mb-1" align="center">{{ props.title }}</TsTypography>
      <TsTypography weight="normal" appendClass="sm:text-natural-grey mb-8 lg:text-natural-grey mb-4" variant="h4" align="center">{{ props.subTitle }}</TsTypography>
      <div class="lg:flex lg:flex-col  flex gap-4  ">
        <div class="flex lg:flex lg:flex-row  flex-col lg:items-center lg:justify-center">
          <div class="bg-white rounded-full h-14 w-14 border-2 border-primary flex flex-col items-center justify-center">
            <TsTypography variant="h2" appendClass="text-primary -mb-2">1</TsTypography>
            <TsTypography variant="h6" appendClass="text-primary mb-1">Step</TsTypography>
          </div>
          <div class="lg:hidden block border w-0 h-16 border-primary border-dashed ml-7"></div>
          <hr class="lg:block hidden w-96 border-1 border-dashed border-primary ">
          <div
            class="bg-white rounded-full h-14 w-14 border-2 border-primary flex flex-col items-center justify-center">
            <TsTypography variant="h2" appendClass="text-primary -mb-2">2</TsTypography>
            <TsTypography variant="h6" appendClass="text-primary mb-1">Step</TsTypography>
          </div>
          <div class="border lg:hidden block w-0 h-16 border-primary border-dashed ml-7"></div>
          <hr class="lg:block hidden w-96 border-1 border-dashed border-primary ">
          <div
            class="bg-white rounded-full h-14 w-14 border-2   border-primary flex flex-col items-center justify-center">
            <TsTypography variant="h2" appendClass="text-primary -mb-2">3</TsTypography>
            <TsTypography variant="h6" appendClass="text-primary mb-1">Step</TsTypography>
          </div>
        </div>
        <div class="lg:flex lg:flex-row flex-col justify-between lg:mt-4 gap-10  ">
          <TsTypography appendClass="lg:w-1/3 lg:pr-10 lg:mb-0 mb-10 tracking-normal lg:text-center">Go to the Toolstation website and navigate to the Pro card registration page.</TsTypography>
          <TsTypography appendClass="lg:w-1/3 lg:pr-10 lg:mb-0 mb-8 tracking-normal lg:text-center">
            Complete the form with your personal and business information, including contact details and any required
            verification documents.</TsTypography>
          <TsTypography appendClass="lg:w-1/3 lg:mb-0 tracking-normal lg:text-center">Submit the
            form
            and wait for the confirmation email. Follow the instructions in the email to activate your Pro card account.
          </TsTypography>
        </div>
      </div>
    </TsNuxtCard>
  </div>
</template>

<script setup lang="ts">

const TsNuxtCard = defineAsyncComponent(
    () => import('~/components/organisms/TsNuxtCard.vue')
);

  type Props = {
    title?: string;
    subTitle?: string;
  };

  const props = withDefaults(defineProps<Props>(), {
    title: 'How PRO card Works?',
    subTitle: 'Becoming a PRO card member is easy',
  });

</script>